import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Popover,
  Select,
  Stack,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import { CSVLink, CSVDownload } from "react-csv";
import SendIcon from "@mui/icons-material/Send";
import React, { useRef } from "react";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import StarsIcon from "@mui/icons-material/Stars";
import { useEffect, useState, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import PreviewIcon from "@mui/icons-material/Preview";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteIcon from "@mui/icons-material/Delete";

import ForwardIcon from "@mui/icons-material/Forward";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../../components/Loader";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { connect } from "react-redux";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";
import EditIcon from "@mui/icons-material/Edit";

import OutboundIcon from "@mui/icons-material/Outbound";

// tablle imports

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { useDispatch, useSelector } from "react-redux";

import dayjs from "dayjs";

import moment from "moment";
import { common_axios } from "../../../../App";
import CheckBox from "../../UserManagement/Tables/CheckBox";
import DashboradTable from "../../Dashboard/DashboradTable";
import DateRangePickerr from "../../Dashboard/DateRangePicker";
// import CheckBox from "./CheckBox";
import ExcelJS from "exceljs";
import * as FileSaver from "file-saver";
import Swal from "sweetalert2";

export default function MarkAttendanceEMP() {
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);

  const [location, setLocation] = React.useState({
    leaveType: "",
    reason: "",
    showlastdiv: false,
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEll, setAnchorEll] = React.useState(null);
  const [data, setData] = useState([
    {
      id: "0",
    },
  ]);
  const [showdata, setshowData] = useState(false);
  const [value, setValue] = React.useState(dayjs(new Date()));
  const [valuee, setValuee] = React.useState();
  const [ee1, setee1] = useState({
    dateform: null,
  });
  const [valueofLeavs, setvalueofLeavs] = useState("");

  const [datee, setdatee] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
  });

  const [daysDiff, setdaysDiff] = useState(1);
  var [date, setDate] = useState(new Date());
  const [employees, setEmployess] = useState([]);
  const [employeesValue, setEmployessValue] = useState(null);
  const [locationvalues, setlocationvalues] = useState(null);
  const [kunuVeer, setkunuVeer] = useState(false);
  const [valueee, setValueee] = React.useState(null);
  const [valueeee, setValueeee] = React.useState(null);
  const [leavesByOthere, setleavesbyOther] = useState([]);
  const [employeeDetails, setemployeeDetails] = useState(undefined);
  const [viewattendance, setviewattendance] = useState(undefined);
  const [buttonsidable, setbuttonDisable] = useState(undefined);
  const [notdatafound, setnotdatafound] = useState(false);
  const [excel, setexcel] = useState([]);
  const [resetModal, setResetModal] = useState({
    year: new Date().getFullYear(),
    month: moment(new Date()).format("MM"),
  });
  const [response, setresponse] = useState("");
  const [responseExcel, setresponseExcel] = useState([]);

  // console.log("dataexcel", excel);

  // by paras --------------------------------------------------------//

  const dates = ["04-01-2023", "05-01-2023"]; // array of dates

  const funexcel = () => {
    // setTimeout(() => {
    //   document.getElementById("emp_data").click();
    // }, 1000);
    // ------------------------------------------------------------------------------------
    // const output = excel.reduce(
    //   (result, { userId, Name, date, statusName }) => {
    //     const item = result.find((r) => r.Name === Name);
    //     console.log({ item });
    //     if (item) {
    //       item[date] = statusName;
    //     } else {
    //       result.push({
    //         Name,
    //         [`${date}`]: statusName,
    //       });
    //     }
    //     return result;
    //   },
    //   []
    // );
    // console.log("kkkkk", output);
    // setresponseExcel(output);
  };

  // by paras ends --------------------------------------------------------//

  // useEffect(() => {
  //   var timer = setInterval(() => setDate(new Date()), 1000);
  //   return function cleanup() {
  //     clearInterval(timer);
  //   };
  // });

  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries
  );

  const mindate = moment(new Date()).subtract(2, "days");

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleChangee = (newValue) => {
    setValuee(newValue);
  };
  var date = moment(valuee?.$d);
  var now = moment(value?.$d);
  var duration = moment.duration(date.diff(now));
  var noofDays = duration.asDays();

  var stat = moment().format("MMMM Do YYYY, h:mm:ss a");

  useEffect(() => {
    setdaysDiff(Math.ceil(noofDays) + 1);
  }, [value?.$d, valuee?.$d]);

  const usermodal = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  const tabSwitch = useRef(null);

  const tabModal = async () => {
    await tabSwitch?.current?.click();
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.no",

        accessor: "S.no",
        Cell: (cell) => {
          return <>{cell.row.index + 1}</>;
        },
      },

      {
        Header: "Room No.",

        accessor: "roomNo",
        Cell: (cell) => (
          <>
            {"88888888"?.substring(0, 5) + "XXXXX"}
            {/* {cell.row.original.enabled ? (
              <>
                <span class="badge badge_8 bg-success">Active</span>
              </>
            ) : (
              <>
                <span class="badge badge_8 bg-warning">De-Active</span>
              </>
            )} */}
            <></>
          </>
        ),
      },
      {
        Header: "Emp Name",

        accessor: "empName",
        Cell: (cell) => (
          <>
            {cell.row.original.firstName && cell.row.original.lastName ? (
              <>
                <span>
                  {cell.row.original.firstName}
                  &nbsp;
                  {cell.row.original.lastName}
                </span>
              </>
            ) : cell.row.original.firstName ? (
              <>{cell.row.original.firstName}</>
            ) : cell.row.original.lastName ? (
              <>{cell.row.original.lastName}</>
            ) : (
              <>
                <span>Not Known</span>
              </>
            )}
          </>
        ),
      },

      {
        Header: "Dept",

        accessor: "dept",
        Cell: (cell) => (
          <>
            {"88888888"?.substring(0, 5) + "XXXXX"}
            {/* {cell.row.original.enabled ? (
              <>
                <span class="badge badge_8 bg-success">Active</span>
              </>
            ) : (
              <>
                <span class="badge badge_8 bg-warning">De-Active</span>
              </>
            )} */}
            <></>
          </>
        ),
      },
      {
        Header: "Contact No.",

        accessor: "contactNo",
        Cell: (cell) => (
          <>
            {"88888888"?.substring(0, 5) + "XXXXX"}
            {/* {cell.row.original.enabled ? (
              <>
                <span class="badge badge_8 bg-success">Active</span>
              </>
            ) : (
              <>
                <span class="badge badge_8 bg-warning">De-Active</span>
              </>
            )} */}
            <></>
          </>
        ),
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          return (
            // <div className="dropdown">
            //   <button
            //     className="btn color_1 px_nx dropdown-toggle"
            //     type="button"
            //     id="dropdownMenuButton1"
            //     data-bs-toggle="dropdown"
            //     aria-expanded="false"
            //   >
            //     <i className="material-icons opacity-10 size">person</i>
            //   </button>
            //   <ul
            //     className="dropdown-menu"
            //     aria-labelledby="dropdownMenuButton1"
            //   >
            //     <li>
            //       <a
            //         className="dropdown-item"
            //         onClick={() => {
            //           editEmployeeModal(cell);
            //         }}
            //       >
            //         <EditIcon sx={{ fontSize: "17px", marginRight: "10px" }} />
            //         View Details
            //       </a>
            //     </li>
            //     <li>
            //       <a
            //         className="dropdown-item"
            //         onClick={() => {
            //           ViewAttendance(cell);
            //           viewAttendanceEmployeeModal(cell);
            //         }}
            //       >
            //         <AutorenewIcon
            //           sx={{ fontSize: "17px", marginRight: "10px" }}
            //         />
            //         View Attendance
            //       </a>
            //     </li>
            //   </ul>
            // </div>
            <>
              <Tooltip title="View Details">
                <IconButton
                  style={{ color: "#4C4234" }}
                  color="#4C4234"
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    editEmployeeModal(cell);
                    tabModal();
                  }}
                >
                  <PreviewIcon style={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Details">
                <IconButton
                  color="#4C4234"
                  style={{ color: "#4C4234" }}
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    // ViewAttendance(cell);
                    viewAttendanceEmployeeModal(cell);
                    tabModal();
                  }}
                >
                  <EditIcon style={{ color: "green" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Checkout">
                <IconButton
                  color="#4C4234"
                  style={{ color: "#4C4234" }}
                  aria-label="upload picture"
                  component="label"
                  onClick={() => {
                    // ViewAttendance(cell);
                    checkoutConfirmation(cell);
                  }}
                >
                  <OutboundIcon style={{ color: "red" }} />
                </IconButton>
              </Tooltip>
            </>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );

  const markAttendence = async (e) => {
    try {
      setOpen(false);
      const res = await common_axios.post(`/attendance/markAttendance`, {
        userId: localStorage.getItem("UserId"),
        status: 1,
        userGroup: usermodal,
        userName: localStorage.getItem("usernamedisplayed"),
      });
      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        // markAttendacne();

        // await setLocation({
        //   ...location,
        //   showlastdiv: true,
        // });

        await setTimeout(async () => {
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      } else {
        setOpen(false);
        // markAttendacne();
        await setTimeout(async () => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescriptions.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    } catch (error) {
      setOpen(false);
      console.log(error);
      await setTimeout(async () => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something Went Wrong !! Please check your network ",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  };
  // const emplopyeebyLocation = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(
  //       `employee/allEmployeeByLocation?locationId=${locationvalues?.id}`
  //     );
  //     if (res.data.statusDescriptions.statusCode == 200) {
  //       setOpen(false);

  //       setData(res.data.adminUserModels);
  //       await setnotdatafound(true);
  //     } else {
  //       setOpen(false);
  //       // markAttendacne();
  //       // await setTimeout(async () => {
  //       //   await toast.error(res.data.statusDescription.statusDescription, {
  //       //     theme: "colored",
  //       //   });
  //       // }, 100);
  //       setresponse(res.data.statusDescriptions.statusDescription);
  //     }
  //   } catch (error) {
  //     setOpen(false);
  //     console.log(error);
  //     await setTimeout(async () => {
  //       // await toast.error("Something went wrong !! Please check your network", {
  //       //   theme: "colored",
  //       // });
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something Went Wrong !! Please check your network ",
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }, 100);
  //   }
  // };

  // useEffect(() => {
  //   if (locationvalues?.id != undefined) {
  //     emplopyeebyLocation();
  //   }
  // }, [locationvalues?.id]);

  const editEmployee = useRef(null);
  const viewAttendance = useRef(null);
  const markAttendacneref = useRef(null);
  const checkoutRef = useRef(null);

  const editEmployeeModal = async (cell) => {
    await setemployeeDetails(cell.row.original);
    await editEmployee.current.click();
  };
  const viewAttendanceEmployeeModal = async (cell) => {
    await setviewattendance(cell.row.original);
    await viewAttendance.current.click();
  };
  const markAttendacnmodal = async () => {
    await markAttendacneref.current.click();
  };
  const checkoutConfirmation = async () => {
    await checkoutRef.current.click();
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setSelectedFlatRows,
    setSelectedRowIds,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      excel,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} id="thissss" />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const deletUser = async () => {
    // console.log({ selectedFlatRows });
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
        // light: "#fff", //overides light blue
        // dark: "#fff", //overides dark blue color
      },
    },
  });

  // const markAttendacne = async () => {
  //   try {
  //     setOpen(true);
  //     const res = await common_axios.post(`/attendance/viewAttendance`, {
  //       userId: localStorage.getItem("UserId"),
  //       year: datee.year,
  //       month: datee.month,
  //     });

  //     if (res.data.statusCode == 200) {
  //       setOpen(false);

  //       setData(res.data.attendanceEntity);

  //       res.data.attendanceEntity.map((e) => {

  //         setee1({
  //           ...e,
  //           dateform: moment(e.date).format("DD-MM-YYYY"),
  //         });
  //       });

  //     } else {
  //       setOpen(false);
  //       await toast.error(res.data.statusDescription.description, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setOpen(false);
  //     await toast.error("Something Went Wrong !! Please check your network ", {
  //       theme: "colored",
  //     });
  //   }
  // };

  useEffect(() => {
    // markAttendacne();

    getAllEmployeesbyCSM();
  }, []);

  const userGrop = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;

  // useEffect(() => {
  //   let newform = moment(new Date()).format("DD-MM-YYYY");
  //   console.log(newform, ee1?.dateform);

  //   if (ee1.dateform == newform) {
  //     setshyamCode(ee1);
  //   }
  // }, [ee1.dateform]);

  const getButtonAdd = useSelector(
    (datar) => datar?.EmployeeSlice?.employeebutton
  );

  const getAllEmployeesbyCSM = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `employee/allEmployeeByCsm?id=${localStorage.getItem("UserId")}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);

        setEmployess(res.data.adminUserModels);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const ViewAttendance = async (cell) => {
    try {
      setOpen(true);
      const res = await common_axios.post(`/attendance/viewAttendance`, {
        userId: cell.row.original?.id,
        year: datee.year,
        month: datee.month,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // setkunuVeer(true);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  // const locationMasterEntities = JSON.parse(
  //   localStorage.getItem("usermodal")
  // )?.locationMasterEntities;
  useEffect(() => {
    if (employeesValue == null || undefined) {
      setkunuVeer(false);
    }
  }, [employeesValue]);

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const leavesByOther = async (dataa1) => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `attendance/leavesByOther?userGroup=${userGrop}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        await setOpen(false);

        // let leavearr = [];
        // for (let i = 0; i < res.data.attendanceDetailsModels.length; i++) {
        //   const ele = res.data.attendanceDetailsModels[i];

        //   if (dataa1?.status != ele?.status) {
        //     leavearr.push(ele);
        //   }
        // }

        // console.log({ leavearr });

        await setleavesbyOther(res.data.attendanceDetailsModels);
      } else {
        await setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      await setOpen(false);
      // await toast.error("Something Went Wrong ! Please Check your NetWork");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  useEffect(() => {
    if (userGrop) {
      leavesByOther();
    }
  }, []);

  const modalMarkClose = useRef(null);

  const usergroup = JSON.parse(localStorage.getItem("usermodal"))?.userGroups;
  const handleChanged = (newValue) => {
    setValueee(moment(newValue?.$d, "MMM-DD-YYYY").format("YYYY-MM-DD"));
  };
  const handleChangedd = (newValue) => {
    setValueeee(moment(newValue?.$d, "MMM-DD-YYYY").format("YYYY-MM-DD"));
  };

  const markAttendacneByCSM = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      let attendanceRequests = [];

      for (let i = 0; i < selectedFlatRows.length; i++) {
        let element = selectedFlatRows[i];

        element.original.fromDate = valueee;
        element.original.status = valueofLeavs;
        element.original.userId = element.original.id;
        element.original.usergroup = usergroup;

        element.original.username = localStorage.getItem("usernamedisplayed");
        attendanceRequests.push(element.original);
      }

      const res = await common_axios.post(`attendance/bulkMarkAttendance`, {
        attendanceRequests: attendanceRequests,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        await modalMarkClose.current.click();
        // await setlocationvalues(null);
        // await emplopyeebyLocation();
        // await buttonCLick.current.click();

        // await toast.success(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // x.toLocaleDateString()
      } else {
        setOpen(false);
        await modalMarkClose.current.click();
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      await modalMarkClose.current.click();
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const buttonCLick = useRef(null);
  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const doownloadExcel = useRef(null);

  const downloadReport = async (e, dataa1) => {
    e.preventDefault();
    try {
      setOpen(true);
      const res = await common_axios.post(`attendance/report`, {
        startDate: valueee,
        endDate: valueeee,
        locationId: locationvalues?.id,
      });

      if (res.data.statusDescriptions.statusCode == 200) {
        let reportResponse = [];

        for (let i = 0; i < res.data.attendanceEntity.length; i++) {
          const element = res.data.attendanceEntity[i];

          // console.log("elementttt", element.date);

          element.date = moment(element.date).format("DD-MM-YYYY");
          element.Name = element.firstName + " " + element.lastName;
          // element.statusName = element.status;
          if (element.employeeUserId) {
            reportResponse.push(element);
          }
        }
        console.log("reporrettss", reportResponse);
        // const customers = res.data.attendanceEntity.reduce(
        //   (m, { employeeUserId: id, ...r }) => {
        //     if (!m.has(id)) m.set(id, []);
        //     return m.get(id).push(r.date), m;
        //   },
        //   new Map()
        // );

        var start = moment(valueee);
        var end = moment(valueeee);

        var list = [];

        for (var current = start; current <= end; current.add(1, "d")) {
          list.push(current.format("YYYY-MM-DD"));
        }

        // console.log({ list });

        const r = reportResponse.push({
          ...reportResponse,
          allDates: list,
        });

        // console.log({ r });

        // const result = res.data.attendanceEntity.reduce((acc, obj) => {
        //   const index = acc.findIndex(
        //     (item) => item.employeeUserId === obj.employeeUserId
        //   );
        //   if (index === -1) {
        //     acc.push({ id: obj.employeeUserId, data: [obj.date] });
        //   } else {
        //     acc[index].data.push(obj);
        //   }
        //   return acc;
        // }, []);

        await setOpen(false);

        const output = await res.data.attendanceEntity.reduce(
          (result, { userId, Name, date, statusName }) => {
            const item = result.find((r) => r.Name === Name);
            // console.log({ item });
            if (item) {
              item[date] = statusName;
            } else {
              result.push({
                Name,
                [`${date}`]: statusName,
              });
            }
            return result;
          },
          []
        );
        await setexcel(output);
        await document.getElementById("close_report").click();
        setTimeout(() => {
          document.getElementById("emp_data").click();
        }, 500);
      } else {
        await setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      await setOpen(false);
      // await toast.error("Something Went Wrong ! Please Check your NetWork");
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const [locationMasterEntities, setlocationMasterEntities] = useState([]);

  const fetchlocation = async () => {
    try {
      setOpen(true);
      const res = await common_axios.post(
        `employee/v1/csmLocation?id=${localStorage.getItem("UserId")}`
      );

      if (res.data.statusDescriptions.statusCode == 200) {
        setOpen(false);
        // alert("hhoo");
        // setEmployess(res.data.adminUserModels);

        // console.log("first", res.data);
        setlocationMasterEntities(res?.data?.locations);

        // x.toLocaleDateString()
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescriptions.statusDescription, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescriptions.statusDescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      console.log(error);
      setOpen(false);
      // await toast.error("Something Went Wrong !! Please check your network ", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something Went Wrong !! Please check your network ",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(() => {
    fetchlocation();
  }, []);

  return (
    <>
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <>
          <button
            ref={editEmployee}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop29"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop29"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5
                    className="modal-title w-100 text-center"
                    id="staticBackdropLabel"
                  >
                    View Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    {/* <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          ref={tabSwitch}
                          // class="nav-link active"
                          class="nav-link active"
                          id="homee-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#homee"
                          type="button"
                          role="tab"
                          aria-controls="homee"
                          aria-selected="true"
                          
                        >
                          Basic Information
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link ms-2"
                          id="profilee-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#profilee"
                          type="button"
                          role="tab"
                          aria-controls="profilee"
                          aria-selected="false"
                        >
                          Bank Details
                        </button>
                      </li>
                    </ul> */}
                    <div class="tab-content mt-3" id="myTabContent">
                      <div
                        class="tab-pane fade show active"
                        id="homee"
                        role="tabpanel"
                        aria-labelledby="homee-tab"
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Floors No.
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.username}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Rooms No.
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.payrollId}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Employee ID:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.organization}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Department:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.location}
                            </span>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Contact No.:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.mobileNo}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Parents Name:
                            </label>
                            <span className=""> {employeeDetails?.email}</span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Parents Contact:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.aadharCard}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Check in date:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.address}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Adhaar Card.:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.uanNumber}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              State.:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.uanNumber}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Check out Date:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.uanNumber}
                            </span>
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Property Name:
                            </label>
                            <span className="">
                              {" "}
                              {employeeDetails?.uanNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="profilee"
                        role="tabpanel"
                        aria-labelledby="profilee-tab"
                      >
                        <div className="row">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Bank Name:
                            </label>
                            {/* <span className=""> {detaiilsOfUser?.[0]?.bank}</span> */}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Acc. No:
                            </label>
                            <span className="">
                              {" "}
                              {/* {detaiilsOfUser?.[0]?.accountNumber} */}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              Bank Branch:
                            </label>
                            {/* <span className=""> {detaiilsOfUser?.[0]?.branch}</span> */}
                          </div>
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              IFSC Code:
                            </label>
                            <span className="">
                              {" "}
                              {/* {detaiilsOfUser?.[0]?.ifscCode} */}
                            </span>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-md-6">
                            <label
                              for="exampleInputEmail1"
                              className="form-label fw-bolder"
                              style={{ fontSize: "13px" }}
                            >
                              PAN No.:
                            </label>
                            <span className="">
                              {" "}
                              {/* {detaiilsOfUser?.[0]?.panNumber} */}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="modal-footer">
                    <button
                      // ref={modelButtonRejectClose}
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        approveUserApi();
                      }}
                    >
                      Approve User
                    </button>
                  </div> */}
                  </div>
                </ThemeProvider>
                <div className="modal-footer">
                  <Button
                    data-bs-dismiss="modal"
                    type="button"
                    variant="contained"
                    sx={{ background: "#F96B02", color: "white" }}
                    endIcon={<CancelIcon />}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <button
            ref={viewAttendance}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop11"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop11"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog  modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5
                    className="modal-title w-100 text-center"
                    id="staticBackdropLabel"
                  >
                    Edit Details
                  </h5>
                  <button
                    // onClick={() => {
                    //   setviewattendance(undefined);
                    //   setResetModal();
                    // }}
                    type="button"
                    className="btn-close m-0"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body">
                    <div class="container-fluid mt-3">
                      <div class="d-block" id="new_store_entry">
                        <div class="card-header p-3 position-relative border-0 bg-white">
                          {/* <DashboradTable
                           
                            notshowpie={true}
                            id={viewattendance?.id}
                            resetcalnder={resetModal}
                           
                          /> */}
                          <div className="modal-body">
                            {/* <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          ref={tabSwitch}
                          // class="nav-link active"
                          class="nav-link active"
                          id="homee-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#homee"
                          type="button"
                          role="tab"
                          aria-controls="homee"
                          aria-selected="true"
                          
                        >
                          Basic Information
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button
                          class="nav-link ms-2"
                          id="profilee-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#profilee"
                          type="button"
                          role="tab"
                          aria-controls="profilee"
                          aria-selected="false"
                        >
                          Bank Details
                        </button>
                      </li>
                    </ul> */}
                            {/* <div class="tab-content mt-3" id="myTabContent">
                              <div
                                class="tab-pane fade show active"
                                id="homee"
                                role="tabpanel"
                                aria-labelledby="homee-tab"
                              > */}
                            <div className="row">
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Floors No.
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.username}
                                </span>
                              </div>
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Rooms No.
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.payrollId}
                                </span>
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Employee ID:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.organization}
                                </span>
                              </div>
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Department:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.location}
                                </span>
                              </div>
                            </div>

                            <div className="row mt-3">
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Contact No.:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.mobileNo}
                                </span>
                              </div>
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Parents Name:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.email}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Parents Contact:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.aadharCard}
                                </span>
                              </div>
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Check in date:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.address}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Adhaar Card.:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.uanNumber}
                                </span>
                              </div>
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  State.:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.uanNumber}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Check out Date:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.uanNumber}
                                </span>
                              </div>
                              <div className="col-md-6">
                                <label
                                  for="exampleInputEmail1"
                                  className="form-label fw-bolder"
                                  style={{ fontSize: "13px" }}
                                >
                                  Property Name:
                                </label>
                                <span className="">
                                  {" "}
                                  {employeeDetails?.uanNumber}
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* <div
                                class="tab-pane fade"
                                id="profilee"
                                role="tabpanel"
                                aria-labelledby="profilee-tab"
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label fw-bolder"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Bank Name:
                                    </label>
                                  
                                  </div>
                                  <div className="col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label fw-bolder"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Acc. No:
                                    </label>
                                    <span className="">
                                    
                                    </span>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label fw-bolder"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Bank Branch:
                                    </label>
                                
                                  </div>
                                  <div className="col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label fw-bolder"
                                      style={{ fontSize: "13px" }}
                                    >
                                      IFSC Code:
                                    </label>
                                    <span className="">
                                   
                                    </span>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <div className="col-md-6">
                                    <label
                                      for="exampleInputEmail1"
                                      className="form-label fw-bolder"
                                      style={{ fontSize: "13px" }}
                                    >
                                      PAN No.:
                                    </label>
                                    <span className="">
                                  
                                    </span>
                                  </div>
                                </div>
                              </div> */}
                          {/* </div> */}

                          {/* <div className="modal-footer">
                    <button
                      // ref={modelButtonRejectClose}
                      type="button"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        approveUserApi();
                      }}
                    >
                      Approve User
                    </button>
                  </div> */}
                          {/* </div>/ */}
                        </div>
                      </div>
                    </div>
                  </div>
                </ThemeProvider>
              </div>
            </div>
          </div>
          <button
            ref={markAttendacneref}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop12"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal mark fade"
            id="staticBackdrop12"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Mark Attendance
                  </h5>
                  <button
                    ref={modalMarkClose}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setValueee(null);
                      setvalueofLeavs(null);
                    }}
                  ></button>
                </div>
                <form onSubmit={markAttendacneByCSM}>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-6">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Select Date"
                              value={valueee}
                              inputFormat="DD/MM/YYYY"
                              disableFuture
                              onError={(e) => {
                                if (e) {
                                  setbuttonDisable(true);
                                } else {
                                  setbuttonDisable(false);
                                }
                              }}
                              onChange={(e) => {
                                handleChanged(e);
                              }}
                              minDate={mindate?._d}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  size="small"
                                  onKeyDown={onKeyDown}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div className="col-6">
                          <FormControl required size="small" fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Status
                            </InputLabel>
                            <Select
                              required
                              size="small"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={valueofLeavs}
                              label="Status"
                              onChange={(e) => {
                                setvalueofLeavs(e.target.value);
                              }}
                            >
                              {leavesByOthere?.map((e) => {
                                return (
                                  <MenuItem value={e?.status}>
                                    {e?.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </ThemeProvider>
                  <div className="modal-footer d-flex justify-content-between">
                    <Button
                      onClick={() => {
                        setValueee(null);
                        setvalueofLeavs("");
                      }}
                      ref={modalMarkClose}
                      data-bs-dismiss="modal"
                      sx={{ marginLeft: "10px", background: "#4C4234" }}
                      variant="contained"
                      endIcon={<CancelIcon />}
                    >
                      Close
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ background: "#F96B02", color: "white" }}
                      endIcon={<SendIcon />}
                      disabled={buttonsidable}
                    >
                      Mark
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <button
            ref={doownloadExcel}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop16"
          >
            Launch static backdrop modal
          </button>

          <button
            ref={checkoutRef}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop91228"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal mark fade"
            id="staticBackdrop91228"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    {/* Status */}
                    Confirmation
                  </h5>
                  <button
                    // ref={markAttendacneref}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    // onClick={() => {
                    //   setstateofButtons({
                    //     approval: false,
                    //     reject: false,
                    //   });
                    // }}
                  ></button>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="modal-body w-100 text-center">
                    <h5> Are you sure to Checkout ?</h5>
                  </div>
                </ThemeProvider>
                <div className="modal-footer d-flex justify-content-between align-items-center">
                  <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#4C4234" }}
                    variant="contained"
                  >
                    No
                  </Button>
                  <Button
                    data-bs-dismiss="modal"
                    sx={{ marginLeft: "10px", background: "#F96902" }}
                    variant="contained"
                    // endIcon={<CheckCircleIcon />}
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal mark fade"
            id="staticBackdrop16"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Download Report
                  </h5>
                  <button
                    id="close_report"
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      setValueee(null);
                      setValueeee(null);
                    }}
                  ></button>
                </div>
                <form onSubmit={downloadReport}>
                  <ThemeProvider theme={theme}>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-6">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="Start Date"
                              value={valueee}
                              inputFormat="DD/MM/YYYY"
                              disableFuture
                              onError={(e) => {
                                if (e) {
                                  setbuttonDisable(true);
                                } else {
                                  setbuttonDisable(false);
                                }
                              }}
                              onChange={(e) => {
                                handleChanged(e);
                                setValueeee(null);
                              }}
                              minDate={addDays(new Date(), -45)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  size="small"
                                  onKeyDown={onKeyDown}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div className="col-6">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              label="End Date"
                              value={valueeee}
                              inputFormat="DD/MM/YYYY"
                              disableFuture
                              onError={(e) => {
                                if (e) {
                                  setbuttonDisable(true);
                                } else {
                                  setbuttonDisable(false);
                                }
                              }}
                              onChange={(e) => {
                                handleChangedd(e);
                              }}
                              minDate={valueee}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  size="small"
                                  onKeyDown={onKeyDown}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                    </div>
                  </ThemeProvider>
                  <div className="modal-footer d-flex justify-content-between">
                    <Button
                      data-bs-dismiss="modal"
                      sx={{ marginLeft: "10px", background: "#4C4234" }}
                      variant="contained"
                      endIcon={<CancelIcon />}
                      onClick={() => {
                        setValueee(null);
                        setValueeee(null);
                      }}
                    >
                      Close
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ background: "#F96B02", color: "white" }}
                      endIcon={<DownloadIcon />}
                    >
                      {/* <CSVLink data={excel}>Submit</CSVLink> */}
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
        <CSVLink id="emp_data" class="d-none" data={excel}>
          Submit
        </CSVLink>

        <div class="container-fluid cont_flui" id="cont_fluid">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 mx-7">
                <p>Employee Records</p>
                {/* <p class="text-sm mb-0 text-capitalize fw-bold">
                  Fields mark with!!
                  <span class="text-danger fw-bold">*</span> are mandatory.
                </p> */}
              </div>
            </div>

            <div class="card-body p-4 mt-5 tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="card card_8 d-block">
                  <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                    <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 text-uppercase ms-2">
                      locations
                    </span>
                  </div>

                  <div class="card-body text-end">
                    {/* <>
                      {selectedTime.start ==
                      moment(new Date()).format("DD-MM-YYYY") ? (
                        <span
                          className="d-sm-inline ms_2 start_date_time_css"
                          style={{
                            backgroundColor: "#F86B02",
                            color: "white",
                          }}
                        >
                          Today
                        </span>
                      ) : selectedTime.start ==
                        moment(addDays(new Date(), -1)).format("DD-MM-YYYY") ? (
                        <span
                          style={{
                            backgroundColor: "#F86B02",
                            color: "white",
                          }}
                          className="d-sm-inline ms_2 start_date_time_css"
                        >
                          Yesterday
                        </span>
                      ) : (
                        <>
                          <span
                            style={{
                              backgroundColor: "#F86B02",
                              color: "white",
                            }}
                            className="d-sm-inline ms_2 start_date_time_css"
                          >
                            {selectedTime.start}
                          </span>
                          <ForwardIcon />
                          <span
                            style={{
                              backgroundColor: "#F86B02",
                              color: "white",
                            }}
                            className="d-sm-inline mx_2 start_date_time_css"
                          >
                            {selectedTime.end}
                          </span>
                        </>
                      )}
                      <IconButton
                        variant="text"
                        size="small"
                        sx={{
                          color: "rgba(0, 0, 0, 0.6)",
                        }}
                        // className="btn bg-gradient-primary "
                        aria-describedby={
                          Boolean(anchorEll) ? "simple-popover" : undefined
                        }
                        onClick={(event) => {
                          setAnchorEll(event.currentTarget);
                        }}
                      >
                        <CalendarMonthIcon />
                      </IconButton>

                      <Popover
                        id={Boolean(anchorEll) ? "simple-popover" : undefined}
                        open={Boolean(anchorEll)}
                        anchorEl={anchorEll}
                        onClose={() => {
                          setAnchorEll(null);
                        }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        <DateRangePickerr />
                      </Popover>
                    </> */}

                    <div className="formisform">
                      {/* <>
                        {JSON.parse(localStorage.getItem("Sidebaritems"))
                          ?.userGroups != 6 ? (
                          <div
                            className="row main_pu_Div"
                            style={{ justifyContent: "space-between" }}
                          >
                            <ThemeProvider theme={theme}>
                              <div className="col-md-3 col-5">
                                <Autocomplete
                                  fullWidth
                                  required
                                  size="small"
                                  disablePortal
                                  id="combo-box-demo"
                                  options={locationMasterEntities}
                                  getOptionLabel={(option) =>
                                    `${option.address}`
                                  }
                                  value={locationvalues}
                                  onChange={(e, val) => {
                                    setlocationvalues(val);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      required
                                      {...params}
                                      size="small"
                                      label="Locations"
                                    />
                                  )}
                                />

                                <button
                                  ref={buttonCLick}
                                  className="d-none"
                                  onDoubleClick={() => {
                                    alert("hello dbl click");
                                    document.getElementById("thissss");
                                  }}
                                >
                                  wsfwefe
                                </button>
                              </div>
                            </ThemeProvider>
                            <div
                              className="d-flex justify-content-end align-items-center col-md-3 col-7"
                              id="mark_in"
                            >
                              {data.length > 0 && (
                                <>
                                  <Button
                                    onClick={() => {
                                      doownloadExcel?.current?.click();
                                    }}
                                    variant="contained"
                                    color="success"
                                  >
                                    <DownloadIcon />
                                  </Button>
                                  <Button
                                    className="ms-2"
                                    onClick={() => {
                                      if (selectedFlatRows.length == 0) {
                                       
                                        Swal.fire({
                                          icon: "error",
                                          title: "Oops...",
                                          text: "Please Select Any Employee First",
                                         
                                        });
                                      } else {
                                        markAttendacnmodal();
                                        deletUser();
                                      }
                                    }}
                               
                                    variant="contained"
                                    style={{ background: "#F67503" }}
                                  >
                                    Mark In
                                  </Button>
                          
                                </>
                              )}
                            </div>
                          </div>
                        ) : null}
                      </> */}

                      <div className="card mb-3 mt-4">
                        {/* {data.length > 0 && locationvalues != null ? ( */}
                        {data.length > 0 ? (
                          <>
                            {/* <hr className="hr_Content" /> */}

                            {/* <div
                              class="d-flex align-items-center w_30 mt_n1 ms-5 me-auto"
                              style={{ width: "40%" }}
                              id="commentDiv"
                            >
                              <i
                                class="fas fa-envelope d-block"
                                aria-hidden="true"
                              ></i>
                              <span class="d-block w-100 text-start text-uppercase ms-2">
                                Employee Records :{" "}
                                <span style={{ color: "#000" }}>
                                  Total No of Employees- ({data?.length})
                                </span>{" "}
                              </span>
                            </div> */}
                            <div className="card-body p-4 pt-1">
                              <div className="d-flex justify-content-between">
                                {/* {searchIcon == true && ( */}
                                <select
                                  value={pageSize}
                                  className="dropdown"
                                  onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                  }}
                                >
                                  {[10, 25, 50].map((value, i) => {
                                    return (
                                      <option
                                        // className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton1"
                                        value={value}
                                        key={value}
                                      >
                                        {" "}
                                        Show {value}
                                      </option>
                                    );
                                  })}
                                </select>
                                {/* )} */}

                                {/* <div>
                                  {allColumns.map((column) => {
                                    return (
                                      <div key={column.id}>
                                        <label>
                                          <input
                                            type="checkbox"
                                            {...column.getToggleHiddenProps()}
                                          />
                                          {column.Header}
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div> */}
                                {/* {searchIcon == true && ( */}
                                <TextField
                                  className="ms-4 "
                                  sx={{
                                    borderRadius: "4px",
                                  }}
                                  type="text"
                                  label="Search"
                                  name="Search"
                                  variant="outlined"
                                  // value={number}
                                  size="small"
                                  value={globalSearchValue || ""}
                                  onChange={(e) => {
                                    onChange(e.target.value);
                                    setGlobalSearchValue(e.target.value);
                                  }}
                                />
                                {/* )} */}
                              </div>

                              <div
                                className="table-responsive t_responsive mt-3"
                                // style={{
                                //   width: "min-content",
                                //   marginLeft: "auto",
                                //   marginRight: "auto",
                                // }}
                              >
                                <table
                                  {...getTableProps()}
                                  id="example"
                                  className="table table-striped table-bordered dataTable table-sm table-responsive"
                                  // className=" table table-responsive table-striped table-bordered dataTable mt-3"
                                >
                                  <thead>
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            className="text-center width_2"
                                          >
                                            {column.render("Header")}
                                            <span>
                                              {column.isSorted
                                                ? column.isSortedDesc
                                                  ? "↑"
                                                  : "↓"
                                                : ""}
                                            </span>
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody id="sub-menu" {...getTableBodyProps()}>
                                    {page.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()}>
                                          {row.cells.map((cell) => {
                                            return (
                                              <td
                                                {...cell.getCellProps()}
                                                className="text-center"
                                              >
                                                {cell.render("Cell")}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-3">
                                <div>
                                  <span>
                                    Page:
                                    <strong>
                                      {/* {pageIndex + 1} of {pageOptions.length} */}
                                      &nbsp; {pageIndex + 1} of{" "}
                                      {pageOptions.length}
                                    </strong>
                                  </span>

                                  {/* <span>
                                    &nbsp; &nbsp; Go to Page : {""}
                                    <input
                                      type="number"
                                      // defaultValue={pageIndex + 1}
                                      value={pageIndex + 1}
                                      onChange={(e) => {
                                        const pageNumber = e.target.value
                                          ? Number(e.target.value) - 1
                                          : 0;
                                        gotoPage(pageNumber);
                                      }}
                                      style={{ width: "50px" }}
                                    />
                                  </span> */}
                                </div>

                                <div id="Nikhil">
                                  <button
                                    className="btn btn_primary m-0 ms-2"
                                    type="button"
                                    style={{
                                      background: "#4C4234",
                                    }}
                                    disabled={!canPreviousPage}
                                    onClick={() => {
                                      previousPage();
                                    }}
                                  >
                                    Prev
                                  </button>

                                  <button
                                    className="btn btn_primary m-0 ms-2"
                                    type="button"
                                    style={{
                                      background: "#F67503",
                                    }}
                                    disabled={!canNextPage}
                                    onClick={() => {
                                      nextPage();
                                    }}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : data?.length == 0 &&
                          open == null &&
                          notdatafound == true ? (
                          <div className="card-body">
                            <div>
                              <h5 style={{ textAlign: "center" }}>
                                No Data Available
                              </h5>
                            </div>
                          </div>
                        ) : data?.length == 0 && open ? (
                          null &&
                          notdatafound ==
                            true(
                              <div className="card-body">
                                <div>
                                  <h5 style={{ textAlign: "center" }}>
                                    {response}
                                  </h5>
                                </div>
                              </div>
                            )
                        ) : null}
                      </div>
                    </div>

                    {/* <div class="text-end my-4">
                        <Button
                          type="submit"
                          //   disabled={buttonDisable}
                          variant="contained"
                          sx={{ background: "#F67503" }}
                          endIcon={<SendIcon />}

                          // onClick={() => {
                          //   // setOpen(true);
                          //   markModal();
                          // }}
                        >
                          Submit
                        </Button>
                      </div> */}
                    {/* {kunuVeer == true ? (
                        // <div class="container-fluid mt-3">
                        <div class="card d-block" id="new_store_entry">
                          <div class="card-header p-3 position-relative border-0 bg-white">
                            <DashboradTable
                              data111={datee}
                              id={employeesValue?.id}
                              userGrop={employeesValue?.userGroups}
                            />
                          </div>
                        </div>
                      ) : // </div>
                      null} */}
                  </div>
                </div>
              </div>

              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
